// extracted by mini-css-extract-plugin
export default {"btn":"ButtonVertion_btn__Cuf-M","pressed":"ButtonVertion_pressed__AGD9Z"};